export const ImpactShopListingType = {
  PROJECT: 'PROJECT',
  IMPACT_FUND: 'IMPACT_FUND',
} as const;

export type ImpactShopListingType = (typeof ImpactShopListingType)[keyof typeof ImpactShopListingType];
